// extracted by mini-css-extract-plugin
export default {"toast":"Toast_toast__jFJHh"};